import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys
);

const sizes = {
  xl: definePartsStyle({
    control: { padding: 3, boxSize: 8, borderWidth: 1, borderColor: 'grey' },
    label: { fontSize: 'md' },
    icon: {
      color: 'blue.400',
      boxSize: '48px',
      fontSize: '3xl'
    }
  })
};

export const checkboxTheme = defineMultiStyleConfig({ sizes });
